import type { MechKey } from './keys';

export const gu: Partial<Record<MechKey, string>> = {
  'app.eyebrow': 'યાંત્રિકી · 2D',
  'panel.scene': 'દ્રશ્ય',
  'panel.dims': 'પ્રાચળ',
  'panel.style': 'દેખાવ',
  'panel.action': 'નિયંત્રણ',
  'style.body': 'વસ્તુ',
  'style.vector': 'સદિશ',
  'style.ground': 'જમીન',
  'style.forces': 'બળ બતાવો',
  'style.trace': 'માર્ગ બતાવો',
  'style.labels': 'સદિશ લેબલ',
  'hint.line1': 'શરૂ કરવા પ્લે ક્લિક કરો · વસ્તુઓ ખેંચો',
  'hint.line2': 'સૅન્ડબૉક્સ: આકાર પસંદ કરો, પછી મૂકવા ક્લિક કરો',
  'scene.incline': 'ઢળતું તળ',
  'scene.projectile': 'અસ્ત્ર ગતિ',
  'scene.pendulum': 'લોલક',
  'scene.springMass': 'સ્પ્રિંગ-દ્રવ્યમાન તંત્ર',
  'scene.collisions': 'અથડામણ',
  'scene.atwood': 'એટવૂડ યંત્ર',
  'scene.circular': 'વૃત્તીય ગતિ',
  'scene.sandbox': 'સૅન્ડબૉક્સ',
  'dim.angle': 'ખૂણો (°)',
  'dim.friction': 'ઘર્ષણ',
  'dim.mass': 'દ્રવ્યમાન',
  'dim.massA': 'દ્રવ્યમાન A',
  'dim.massB': 'દ્રવ્યમાન B',
  'dim.velocity': 'વેગ',
  'dim.angleLaunch': 'પ્રક્ષેપણ ખૂણો (°)',
  'dim.gravity': 'ગુરુત્વ',
  'dim.gravityX': 'ગુરુત્વ x',
  'dim.gravityY': 'ગુરુત્વ y',
  'dim.length': 'લંબાઈ',
  'dim.damping': 'અવમંદન',
  'dim.spring': 'કઠોરતા',
  'dim.restitution': 'પ્રત્યાસ્થિતતા',
  'dim.radius': 'ત્રિજ્યા',
  'dim.speed': 'ઝડપ',
  'action.play': 'ચલાવો',
  'action.pause': 'અટકાવો',
  'action.step': 'પગલું',
  'action.reset': 'રીસેટ',
  'action.speed': 'ઝડપ',
  'action.clear': 'સાફ કરો',
  'force.gravity': 'Fg',
  'force.normal': 'N',
  'force.friction': 'Ff',
  'force.tension': 'T',
  'force.spring': 'Fs',
  'force.applied': 'Fa',
  'force.air': 'Fd',
  'forceName.gravity': 'ગુરુત્વ બળ',
  'forceName.normal': 'અભિલંબ બળ',
  'forceName.friction': 'ઘર્ષણ બળ',
  'forceName.tension': 'તનાવ',
  'forceName.spring': 'સ્પ્રિંગ બળ',
  'forceName.applied': 'આરોપિત બળ',
  'forceName.air': 'વાયુ અવરોધ',
  'palette.box': 'પેટી',
  'palette.circle': 'ગોળ',
  'palette.ramp': 'ઢળ',
  'palette.ground': 'જમીન',
  'palette.hint': 'આકાર પસંદ કરો, પછી મૂકવા કૅનવાસ પર ક્લિક કરો.',
  'panel.forces': 'જોવાયેલ બળ',
  'forces.empty': 'હજુ કશું નહીં — દ્રશ્ય ચલાવો',
};
